import { render, staticRenderFns } from "./custom-select-score.vue?vue&type=template&id=3643cb9a&scoped=true&"
import script from "./custom-select-score.vue?vue&type=script&lang=js&"
export * from "./custom-select-score.vue?vue&type=script&lang=js&"
import style0 from "./custom-select-score.vue?vue&type=style&index=0&id=3643cb9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643cb9a",
  null
  
)

export default component.exports